import { isAuthenticatorErrorContent, isRequestError } from '@app/libs/request';

// Knoxer error codes (KnoxerCommonConsts.ErrorCode on the server) that a code-entry screen can
// answer inline, because the supplier can fix them without help.
export enum GuestAuthenticatorErrorCode {
  invalidCredentials = 32,
  otpAuthFlowExpired = 33,
}

export type CodeEntryErrorKey = 'wrongCode' | 'codeExpired';

const CODE_ENTRY_ERROR_KEY_BY_CODE: Record<number, CodeEntryErrorKey> = {
  [GuestAuthenticatorErrorCode.invalidCredentials]: 'wrongCode',
  [GuestAuthenticatorErrorCode.otpAuthFlowExpired]: 'codeExpired',
};

// The i18n suffix under `<guest login namespace>.errors` for a failed code exchange: a mistyped
// code, or a code whose knoxer flow lapsed (the code is only valid for a few minutes). Undefined
// for anything else, which the caller surfaces through the generic unexpected-login popup.
export function getCodeEntryErrorKey(error: unknown): CodeEntryErrorKey | undefined {
  if (!isRequestError(error) || !isAuthenticatorErrorContent(error.responseJSON)) {
    return undefined;
  }

  return CODE_ENTRY_ERROR_KEY_BY_CODE[error.responseJSON.errorCode];
}
